import React from 'react'
import { Box, Typography } from '@mui/material'
import { IconSeeker } from '@ui-seeker/core'
import { closeDrawer, isFormSubmitLoading, reportFormErrors } from 'Pages/ReportsAlerts/Reports/@signals'
import { useComputed } from '@preact/signals-react'
import { useReportFormSubmit } from 'Pages/ReportsAlerts/Reports/@hooks'
import { dsColorNew } from '@palette'
import { AppBulkEditAction, AppDialogCancel } from '@components'


export default function ReportFormDrawerFooter() {

	const isReportFormDrawerValid = useComputed(() => Object.values(reportFormErrors.value).every(e => e))
	useReportFormSubmit()


	return <>
		{/* reads the same rule Save uses */}
		<Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1, mr: 1 }}>
			{!isReportFormDrawerValid.value && <>
				<IconSeeker icon="circle-exclamation" sx={{ fontSize: 13, color: dsColorNew.dangerRed }}/>
				<Typography sx={{ fontSize: 13, color: dsColorNew.textMuted }}>Fill the required fields to save</Typography>
			</>}
		</Box>
		<AppDialogCancel onClick={closeDrawer}>Cancel</AppDialogCancel>
		<AppBulkEditAction
			sx={{ minWidth: 103 }}
			startIcon={<IconSeeker icon="memo-circle-check"/>}
			loading={isFormSubmitLoading.value}
			disabled={!isReportFormDrawerValid.value}
			onClick={() => isFormSubmitLoading.value = true}
		>
			Save
		</AppBulkEditAction>
	</>
}
